import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">为什么选择天美影视</h2>
          <p className="mt-2 text-sm text-foreground-500">用技术和服务，给你最好的观影体验</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full mb-4 ${
                idx === 0 ? 'bg-primary-100 text-primary-600' :
                idx === 1 ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}